import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const InspectionDefault = ({ cansurvey }) => {
  const { t } = useTranslation();
  const jangruboy_wow = "/images/mo/jangruboy_wow.svg";
  const navigate = useNavigate();

  return (
    <>
      {cansurvey && cansurvey.canSurvey === true ? (
        <>
          <div className="flex flex-col justify-center items-center pt-[119px]">
            <img src={jangruboy_wow} alt="jangruboy_wow" />
            <br />
            <div>{t('InspectionDefault_noRecords', '아직 저장된 기록이 없네요!')}</div>
            <div className="pt-[16px]">{t('InspectionDefault_readyToCheck', '점검할 준비가 되셨다면')}</div>
            <div>{t('InspectionDefault_pressStart', '시작하기 버튼을 눌러주세요.')}</div>
          </div>
          <div className="mt-[48px] w-full px-[24px]">
            <div
              className=" bg-[#1B5EDC] text-white buttom_700 py-[20px] cursor-pointer text-center hover:bg-[#18428E] rounded-full cursor-pointer  ease-in-out duration-300"
              onClick={() => navigate("/check")}
            >
              {t('InspectionDefault_start', '시작하기')}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-col justify-center items-center pt-[119px]">
            <img src={jangruboy_wow} alt="jangruboy_wow" />
            <br />
            <div>{t('InspectionDefault_checkDateIs', '{{name}}님의 점검날짜는', { name: cansurvey ? cansurvey.patient.name : "" })}</div>
            <div>
              {t('InspectionDefault_everyMonth', '매월 {{day1}}일, {{day2}}일 입니다.', { day1: cansurvey ? cansurvey.patient.surveyDay[0] : "", day2: cansurvey ? cansurvey.patient.surveyDay[1] : "" })}
            </div>

            {cansurvey && dayjs() < dayjs(cansurvey.patient.surveyDay[2]) ? (
              <span className="block text-sm">
                <br />
                {t('InspectionDefault_firstCheckDate', '첫번째 점검일 : {{date}}', { date: dayjs(cansurvey.patient.surveyDay[2]).format("YYYY년 M월 D일") })}
              </span>
            ) : (
              <>
                <div className="pt-[32px]">{t('InspectionDefault_whenCheckDateComes', '정기 점검 날짜가 다가오면')}</div>
                <div>{t('InspectionDefault_weWillNotify', '저희가 알림을 드릴게요!')}</div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default InspectionDefault;
